<div class="re-inline-block re-w-full re-border-t-5 re-border-t-primary re-bg-white">
  <div class="re-flex re-flex-col md:re-flex-row md:re-justify-between">
    <div class="re-order-2 md:re-order-1 re-p-15 md:re-mr-30 md:re-w-1/2 md:re-flex md:re-flex-col md:re-justify-between md:re-p-30">
      <div>
        <h4 class="re-mb-15 md:re-mb-30">{{ alertHeadline }}</h4>
        <p class="re-mb-45 md:re-mb-60" [innerHTML]="alertText"></p>
      </div>
      <a [routerLink]="routerUrl" [queryParams]="queryParams" class="re-button re-primary re-inline-block md:re-w-max" (click)="inspectAlert(alert)" [target]="newTab ? '_blank' : '_self'">
        {{ linkText }}
      </a>
    </div>
    <img class="re-w-full re-order-1 re-mb-10  re-object-contain md:re-w-[40%] md:re-max-w-440 md:re-order-2 md:re-mb-0"
      [src]="alertImage"
      alt=""
    >
  </div>
</div>
